export const Heading = () => {
  return (
    <div
      css={`
        font-size: 28px;
        font-style: normal;
        font-weight: 600;
        font-family: "Pretendard", sans-serif;
        line-height: 40px;
        letter-spacing: -0.48px;
        text-align: center;

        @media (min-width: 960px) {
          font-size: 40px;
          line-height: 60px;
        }
      `}
    >
      Manage cases for your clients and employees more efficiently
    </div>
  );
};
